import { BulkSpreadsheet, parseBool, parseInt10, type BulkColumn } from '../shared/BulkSpreadsheet';
import { menuService } from '@kss/api';
import type { MenuCreate } from '@kss/api';
import { loadMenuOptions } from '../shared/formLoaders';

const columns: BulkColumn<MenuCreate>[] = [
  { key: 'name', header: 'Name', required: true, sample: 'Dashboard' },
  { key: 'icon', header: 'Icon', sample: 'LayoutDashboard' },
  { key: 'path', header: 'Path', sample: '/panel/dashboard' },
  { key: 'parentId', header: 'Parent', dataType: 'lookup', loadOptions: loadMenuOptions },
  { key: 'sortOrder', header: 'Sort', dataType: 'integer', parse: parseInt10 as never, sample: '10' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkMenu() {
  return (
    <BulkSpreadsheet<MenuCreate> title="Bulk import menus" entityLabel="menu" backPath="/panel/menus" columns={columns} module="Menu"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await menuService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
